import React, { useEffect } from 'react'
import 'feather-icons'
import { TYPE } from '../Theme'
import Panel from '../components/Panel'
import { useAllPairData } from '../contexts/PairData'
import PairList from '../components/PairList'
import { PageWrapper, FullWrapper } from '../components'
import { RowBetween } from '../components/Row'
import { useMedia } from 'react-use'
import ScrollUp from '../components/ScrollUp'

function AllPairsPage() {
  const allPairs = useAllPairData()
  const below800 = useMedia('(max-width: 800px)')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <PageWrapper>
      <FullWrapper>
        <ScrollUp />
        <RowBetween>
          <TYPE.largeHeader>Top Pairs</TYPE.largeHeader>
        </RowBetween>
        <Panel style={{ padding: below800 && '1rem 0 0 0 ' }}>
          <PairList pairs={allPairs} disableLinks={false} maxItems={50} />
        </Panel>
      </FullWrapper>
    </PageWrapper>
  )
}

export default AllPairsPage
